import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../store/authStore';
import { useSubscriptionStore } from '../../../store/subscriptionStore';
import { dodoService } from '../../../services/dodoService';

export const useGetStarted = () => {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const { isSubscribed } = useSubscriptionStore();
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleGetStarted = async () => {
    if (!user) {
      // Not signed in - go to signup
      navigate('/?mode=signup');
    } else if (!isSubscribed) {
      // Signed in but not subscribed - start checkout
      try {
        setIsLoading(true);
        await dodoService.redirectToCheckout(import.meta.env.VITE_DODO_PRODUCT_ID, user.id, user.email!);
      } catch (error) {
        console.error('Subscription error:', error);
      } finally {
        setIsLoading(false);
      }
    } else {
      // Signed in and subscribed - go to dashboard
      navigate('/?mode=dashboard&section=projects');
    }
  };

  return {
    handleGetStarted,
    showSubscriptionModal,
    setShowSubscriptionModal,
    isLoading
  };
}; 